(function () {
  'use strict';

  var hub = document.querySelector('[data-project-hub]');
  if (!hub) return;

  var QUOTE_KEY = 'mrparquet:project-quote:v1';
  var CHAT_SCRIPT_ID = 'QuoteFlowChatWidgetScript';
  var CHAT_SCRIPT_URL = 'https://flow.mrparquet.com.uy/widget/chat-widget.js';
  var returnFocus = null;
  var quoteCount = 0;
  var sampleCount = 0;
  var chatPromise = null;
  var sampleVariantId = Number(document.querySelector('[data-sample-variant-id]')?.dataset.sampleVariantId || 0);

  function focusables() {
    return Array.prototype.slice.call(hub.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])'))
      .filter(function (element) { return !element.hidden && element.offsetParent !== null && !element.matches('.pq-backdrop'); });
  }

  function readQuoteCount() {
    try {
      var state = JSON.parse(localStorage.getItem(QUOTE_KEY) || 'null');
      return state && Array.isArray(state.items) ? state.items.length : 0;
    } catch (_) {
      return 0;
    }
  }

  function updateBadge() {
    var total = quoteCount + sampleCount;
    document.querySelectorAll('[data-project-hub-count]').forEach(function (badge) {
      badge.textContent = String(total);
      badge.hidden = total === 0;
    });
  }

  function updateQuote() {
    quoteCount = readQuoteCount();
    var summary = hub.querySelector('[data-project-hub-quote-summary]');
    var action = hub.querySelector('[data-project-hub-quote]');
    if (summary) summary.textContent = quoteCount ? quoteCount + (quoteCount === 1 ? ' producto' : ' productos') : 'Sin productos';
    if (action) action.firstChild.textContent = quoteCount ? 'Revisar presupuesto ' : 'Comenzar presupuesto ';
    updateBadge();
  }

  function updateSamples() {
    var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return fetch(rootPath + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error(); return response.json(); })
      .then(function (cart) {
        var samples = (cart.items || []).filter(function (item) {
          return Number(item.variant_id) === sampleVariantId && item.properties && item.properties.Muestra;
        });
        sampleCount = samples.reduce(function (total, item) { return total + Number(item.quantity || 0); }, 0);
        var summary = hub.querySelector('[data-project-hub-sample-summary]');
        var total = hub.querySelector('[data-project-hub-sample-total]');
        var progress = hub.querySelector('[data-project-hub-sample-progress]');
        var action = hub.querySelector('[data-project-hub-samples]');
        if (summary) summary.textContent = sampleCount + ' de 3';
        if (total) total.textContent = sampleCount ? 'USD ' + (sampleCount * 5) + ' + IVA' : 'USD 5 + IVA c/u';
        if (progress) {
          progress.setAttribute('aria-valuenow', String(Math.min(sampleCount, 3)));
          progress.style.setProperty('--project-sample-progress', Math.min(sampleCount / 3 * 100, 100) + '%');
        }
        if (action) {
          action.href = sampleCount >= 3 ? action.dataset.cartUrl : action.dataset.browseUrl;
          action.firstChild.textContent = sampleCount >= 3 ? 'Ver muestras en carrito ' : (sampleCount ? 'Completar selección ' : 'Elegir muestras ');
        }
        updateBadge();
      })
      .catch(function () {
        sampleCount = 0;
        updateBadge();
      });
  }

  function openHub(trigger) {
    returnFocus = trigger || document.activeElement;
    updateQuote();
    updateSamples();
    hub.hidden = false;
    hub.setAttribute('aria-hidden', 'false');
    document.body.classList.add('project-hub-lock');
    document.querySelectorAll('[data-project-hub-open]').forEach(function (button) { button.setAttribute('aria-expanded', 'true'); });
    window.requestAnimationFrame(function () {
      var target = hub.querySelector('.project-hub__header [data-project-hub-close]') || hub.querySelector('[role="dialog"]');
      if (target) target.focus();
    });
  }

  function closeHub(restore) {
    hub.hidden = true;
    hub.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('project-hub-lock');
    document.querySelectorAll('[data-project-hub-open]').forEach(function (button) { button.setAttribute('aria-expanded', 'false'); });
    if (restore !== false && returnFocus && returnFocus.focus) returnFocus.focus();
  }

  function setChatStatus(message, isError) {
    var status = hub.querySelector('[data-project-hub-chat-status]');
    if (!status) return;
    status.textContent = message || '';
    status.hidden = !message;
    status.classList.toggle('is-error', Boolean(isError));
  }

  function loadChat() {
    if (window.QuoteFlowWidget) return Promise.resolve(window.QuoteFlowWidget);
    if (chatPromise) return chatPromise;

    chatPromise = new Promise(function (resolve, reject) {
      var existing = document.getElementById(CHAT_SCRIPT_ID);
      if (existing) {
        existing.addEventListener('load', function () { resolve(window.QuoteFlowWidget); }, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.id = CHAT_SCRIPT_ID;
      script.src = CHAT_SCRIPT_URL;
      script.dataset.tenant = 'mrparquet';
      script.dataset.title = 'Asesoría Mr. Parquet';
      script.dataset.subtitle = 'Conversemos sobre tu proyecto';
      script.dataset.color = '#303233';
      script.addEventListener('load', function () {
        if (window.QuoteFlowWidget) resolve(window.QuoteFlowWidget);
        else reject(new Error('QuoteFlow no quedó disponible.'));
      }, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    }).catch(function (error) {
      chatPromise = null;
      throw error;
    });

    return chatPromise;
  }

  function hideStandaloneChatLauncher() {
    document.querySelectorAll('.qf-bubble,.qf-teaser').forEach(function (element) {
      element.hidden = true;
      element.style.display = 'none';
    });
    Array.prototype.forEach.call(document.body.children, function (host) {
      if (!host.shadowRoot) return;
      host.shadowRoot.querySelectorAll('.qf-bubble,.qf-teaser').forEach(function (element) {
        element.hidden = true;
        element.style.display = 'none';
      });
    });
  }

  function openChat(button) {
    setChatStatus('Abriendo el chat…', false);
    button.disabled = true;

    loadChat().then(function (widget) {
      var context = button.dataset.qfProductName ? {
        name: button.dataset.qfProductName,
        sku: button.dataset.qfProductSku || undefined,
        url: button.dataset.qfProductUrl || window.location.href
      } : undefined;
      closeHub(false);
      widget.open(context);
      hideStandaloneChatLauncher();
      window.setTimeout(hideStandaloneChatLauncher, 250);
      window.setTimeout(hideStandaloneChatLauncher, 1000);
      setChatStatus('', false);
    }).catch(function () {
      setChatStatus('No pudimos abrir el chat. Probá nuevamente o escribinos por WhatsApp.', true);
    }).finally(function () {
      button.disabled = false;
    });
  }

  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-project-hub-open]');
    if (open) {
      event.preventDefault();
      openHub(open);
      return;
    }

    if (event.target.closest('[data-project-hub-close]')) {
      event.preventDefault();
      closeHub(true);
      return;
    }

    var quote = event.target.closest('[data-project-hub-quote]');
    if (quote) {
      event.preventDefault();
      if (quoteCount > 0) {
        closeHub(false);
        document.querySelector('[data-pq-resume]')?.click();
      } else {
        window.location.href = quote.dataset.builderUrl;
      }
      return;
    }

    var chat = event.target.closest('[data-project-hub-chat]');
    if (chat) {
      event.preventDefault();
      openChat(chat);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (hub.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeHub(true);
      return;
    }
    if (event.key !== 'Tab') return;
    var elements = focusables();
    if (!elements.length) return;
    var first = elements[0];
    var last = elements[elements.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  document.addEventListener('project-quote:change', updateQuote);
  document.addEventListener('cart:refresh', function () { window.setTimeout(updateSamples, 80); });
  document.addEventListener('cart:updated', function () { window.setTimeout(updateSamples, 80); });
  window.addEventListener('pageshow', function () { updateQuote(); updateSamples(); });
  updateQuote();
  updateSamples();
  if (window.location.hash === '#project-hub') {
    window.setTimeout(function () { openHub(document.querySelector('[data-project-hub-open]')); }, 80);
  }
})();
